import React from 'react';
import Dialog from '../Dialog';

interface AddCommentDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    commentText: string;
    setCommentText: (text: string) => void;
    commentError: string;
    setCommentError: (error: string) => void;
    isSubmitting: boolean;
}

const AddCommentDialog: React.FC<AddCommentDialogProps> = ({
    isOpen,
    onClose,
    onSubmit,
    commentText,
    setCommentText,
    commentError,
    setCommentError,
    isSubmitting
}) => {
    const handleClose = () => {
        onClose();
        setCommentText('');
        setCommentError('');
    };

    return (
        <Dialog
            isOpen={isOpen}
            width="w-[600px]"
            padding="px-6 py-6"
            onClose={handleClose}
            className="z-[60]"
        >
            <div className="text-center">
                <h3 className="text-2xl font-semibold mb-6">Add New Comment</h3>

                <div className="mb-6">
                    <textarea
                        className={`w-full px-4 py-3 text-sm border ${commentError ? 'border-red-500' : 'border-gray-300'
                            } rounded-lg shadow-sm focus:outline-none focus:ring-1 focus:ring-black focus:border-black
                            min-h-[120px] max-h-[200px] resize-none overflow-y-auto`}
                        placeholder="Enter your comment here..."
                        value={commentText}
                        onChange={(e) => {
                            setCommentText(e.target.value);
                            if (e.target.value.trim()) {
                                setCommentError('');
                            }
                        }}
                        id="comment-textarea"
                        rows={4}
                    />
                    {commentError && (
                        <p className="text-sm text-red-600 text-left mt-1">{commentError}</p>
                    )}
                </div>

                <div className="flex justify-end gap-3">
                    <button
                        onClick={handleClose}
                        className="btn-secondary"
                        id="cancel-comment-button"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onSubmit}
                        className="btn-primary"
                        disabled={isSubmitting}
                        id="submit-comment-button"
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default AddCommentDialog; 